import React, { useState, useEffect } from "react";
import {
  CardContainer,
  SideCardContainer,
} from "../all-containers/general";
import { Background } from "../background/background";
import { SectionItem } from "../section-item/sectionItem";
import styles from "./container.module.css";
import { Title } from "../titles/titles";
import { Ussd } from "../ussd/ussd";
import { Bank } from "../bank/bank";
import { Wallets } from "../wallet/wallet";
import { PayAttitude } from "../payAttitude/pay";
import {
  InProccess,
  OTPOverlay,
  PaymentFailed,
  PaymentSuccess,
  PlsWait,
} from "../modal/container";
import { SVGS } from "../../assets/svgs";
import { NormalText } from "../normalText/normalText";
import { useDispatch, useSelector } from "react-redux";
import { Dispatach_New_Tab } from "../../redux/actions/account";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config.js";
import logo3 from "../../assets/quickLogo.png";
import { BankTransfer } from "../BankTransfer/BankTransfer.jsx";
import { TopUpCardContents } from "../topupCard/topupCardContainer.jsx";
import { TopUpUssd } from "../topUpUssd/topUpUssd.jsx";
import { notifyOpener } from "../../utils/openerMessaging";

const {
  Ussd: USSD,
  bankIcon,
  credit_card,
  wallet,
  call_button,
  cardSect,
  transferIcon,
  // logo3,
  backLogo,
} = SVGS;


export const TopUpContainer = () => {
  const [modals, setModals] = useState("");
  const [tabs, setTabs] = useState(1);
  const active = useSelector((state) => state.tabs);
  const Dispatch = useDispatch();
  const [companyName, setCompanyName] = useState(null);
  const [menus, setMenus] = useState([]);
  const [searchParams] = useSearchParams();
  const [merchantId, setMerchantId] = useState(null);
  const [amount, setAmount] = useState(null);
  const [publicKey, setPublicKey] = useState(null);
  const [businessName, setBusinessName] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState({});




  useEffect(() => {
    const amount = searchParams.get("amount") ?? JSON.parse(sessionStorage.getItem("amount")) ?? '';
    const merchantId = searchParams.get("merchantId");
    const businessName = searchParams.get("businessName") ?? JSON.parse(sessionStorage.getItem("businessName"));
    const wayaPublicKey = searchParams.get("publicKey") ?? JSON.parse(sessionStorage.getItem("publicKey"));
    setMerchantId(merchantId)
    setAmount(amount)
    setBusinessName(businessName)
    setPublicKey(wayaPublicKey)
    if (!amount || !merchantId || !wayaPublicKey) {
      // toast.error("Missing required params");

      notifyOpener({ type: "PAYMENT_ERROR", message: "Invalid request" });

      window.close();
      return;
    }
    const topupDetails = {
      amount: Number(amount),
      customer: {
        merchantId,
        businessName,
        wayaPublicKey
      },
    };

    setTransactionDetails(topupDetails);
    if (sessionStorage.getItem("otherInfo")) {
      setCompanyName(
        JSON.parse(sessionStorage.getItem("otherInfo") || "Wallet Topup").otherDetails.organisationName
      );
    }

    fetchPaymentOptions(merchantId);


  }, [searchParams]);

  const fetchPaymentOptions = (merchantId) => {
    let paymentOptionsList = [];

    axios
      .get(
        `${config.API_ROOT}/wayapay-identity-manager/api/v1/waya-merchant/configuration/payment-preference?merchantId=${merchantId}`
      )
      .then((result) => {
        const paymentOption = result.data.data;

        if (paymentOption.payWithCardEnabled) {
          paymentOptionsList.push({
            title: "Card",
            description: "Mastercard, Verve, Visa",
            img: credit_card,
          });
        }

        if (paymentOption.payWithUSSDEnabled) {
          paymentOptionsList.push({
            title: "USSD",
            description: "Pay with USSD code",
            img: USSD,
          });
        }

        if (paymentOption.payWithWalletEnabled) {
          paymentOptionsList.push({
            title: "Account",
            description: "Pay from your account",
            img: wallet,
          });
        }

        if (paymentOption.payWithBankEnabled) {
          paymentOptionsList.push({
            title: "Bank",
            description: "Pay from your bank",
            img: bankIcon,
          });
        }

        if (paymentOption.payWithPayAttitudeEnabled) {
          paymentOptionsList.push({
            title: "PayAttitude",
            description: "Pay with phone number",
            img: call_button,
          });
        }

        // Always allow transfer for topup
        paymentOptionsList.push({
          title: "Pay with transfer",
          description: "Transfer to account",
          img: transferIcon,
        });

        setMenus(paymentOptionsList);
      });
  };

  const handleTabChange = (value) => {
    Dispatach_New_Tab(Dispatch, value);
  };

  const renderItems = () => {
    return (
      <>
        <div style={{ display: active === "Card" ? "block" : "none" }}>
          <TopUpCardContents modals={setModals} amountProp={amount} merchantId={merchantId} businessName={businessName} publicKey={publicKey} />
        </div>
        <div style={{ display: active === "USSD" ? "block" : "none" }}>
          <TopUpUssd amount={amount} merchantId={merchantId} businessName={businessName} />
        </div>
        <div style={{ display: active === "Bank" ? "block" : "none" }}>
          <Bank />
        </div>
        <div style={{ display: active === "Pay with transfer" ? "block" : "none" }}>
          <BankTransfer />
        </div>
        <div style={{ display: active === "Account" ? "block" : "none" }}>
          <Wallets
            // setTranId={setMerchantId}

            tranId={merchantId}
            transaction={transactionDetails}
          />
        </div>
        <div style={{ display: active === "PayAttitude" ? "block" : "none" }}>
          <PayAttitude />
        </div>
      </>
    );
  };

  const cancelPageHandler = () => {
    const isPopup = window.opener && !window.opener.closed;

    if (isPopup) {
      notifyOpener({ type: "PAYMENT_CANCELLED" });
      window.close();
    } else {
      window.history.go(-1);
    }
  };

  return (
    <Background>
      <div className={`${styles.container}`}>
        <div className={`${styles.controls}`}>
          <div className={styles.logs}>
            <div className={styles.logostyles}>
              <img src={logo3} alt="" width="150px" />
              <button
                onClick={() => cancelPageHandler()}
                className={styles.cancelBtn}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.85571 6.5L13 11.6443V13H11.6443L6.5 7.85571L1.35571 13H0V11.6443L5.14429 6.5L0 1.35571V0H1.35571L6.5 5.14429L11.6443 0H13V1.35571L7.85571 6.5Z"
                    fill="white"
                  />
                </svg>
                Cancel
              </button>
            </div>
          </div>
        </div>
        <CardContainer>
          <div className={styles.secondOption}>
            {menus?.map((el) => (
              <div
                active={active}
                onClick={() => handleTabChange(el.title)}
                className={`${styles.eachMobileMenu} ${el.title === active && styles.active
                  }`}
              >
                <img src={el.img} width="30" height="30" alt="" />
              </div>
            ))}
          </div>
          <SideCardContainer classStyles={styles.hidden}>
            <p
              style={{
                paddingLeft: "18px",
                marginBottom: 2,
                fontSize: "13px",
              }}
            >
              Top Up Wallet of
            </p>

            <h5
              style={{
                paddingLeft: "18px",
                textTransform: "uppercase",
                marginTop: 4,
                fontSize: 16,
              }}
            >
              {companyName}
            </h5>
            <Title
              size={15}
              title={
                active === "Card"
                  ? "SELECT YOUR PREFERRED PAYMENT METHOD"
                  : `SELECT PAYMENT METHOD`
              }
            />
            {menus?.map((el) => (
              <SectionItem
                title={`${el.title}`}
                description={`${el.description}`}
                active={active}
                setActive={handleTabChange}
              >
                <img src={el.img} width="30" height="30" alt="" />
              </SectionItem>
            ))}
          </SideCardContainer>
          <SideCardContainer>{renderItems()}</SideCardContainer>
        </CardContainer>
        <div className={`${styles.bottom}`}>
          <fieldset
            style={{ borderRadius: 10, borderColor: "var(--red)", padding: 10 }}
          >
            <legend align="center">Payment secured by WayaQuick</legend>
            <img src={cardSect} alt="" width="300" />
          </fieldset>
          <div style={{ width: "100%", marginTop: 14, marginBottom: 5 }}>
            <NormalText size={12} align="center">
              Accept, Process and Disburse Digital Payments for your business
              <br />
              <a
                href="https://wayaquick.com"
                target="_blank"
                style={{ color: "red" }}
                rel="noopener noreferrer"
              >
                {" "}
                Learn More
              </a>
            </NormalText>
          </div>
        </div>
      </div>
      {/* <div className={`${styles.container}`}></div> */}

      {/* MODALS */}
      {modals === "proccess" && (
        <InProccess
          cancel={() => {
            setModals("");
            setTabs(1);
          }}
        />
      )}
      {modals === "otp" && (
        <OTPOverlay
          cancel={() => {
            setModals("");
            setTabs(1);
          }}
        />
      )}
      {modals === "success" && <PaymentSuccess />}
      {modals === "failed" && <PaymentFailed />}
      {modals === "wait" && <PlsWait />}
    </Background>
  );
};